import React, { useEffect, useState } from 'react';
import {
    IonContent, IonPage, 
    IonSlides, IonSlide
} from '@ionic/react';

import { useAuth0 } from "@auth0/auth0-react";

import Button from '@material-ui/core/Button';

import Typography from '@material-ui/core/Typography';

import AppBar from '@material-ui/core/AppBar';

import useStyles from '../assets/cssClasses';
import { Capacitor } from '@capacitor/core';


import {
    Toolbar,
    Grid,

    Card,
    CardContent,

} from '@material-ui/core';

import { firebase } from '../assets/firebase'
const slideOpts = {
    initialSlide: 0,
    speed: 400,
    dir: 'rtl',
};

interface dbProps {
    ios: Boolean,
  }

const HowToUse: React.FC<dbProps> = (props) => {
    const { loginWithRedirect, logout, user, isAuthenticated } = useAuth0();
    const classes = useStyles();

    const [slides, setSlides] = useState<Array<any>>([]);


    useEffect(() => {
        console.log(slides)
    }, [slides])

    useEffect(() => {
        var store = firebase.storage()

        store.ref('/pages/howto_slides.js').getDownloadURL().then(function (url) {
            console.log(url);
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'text';
            xhr.onload = function (event) {
                //alert(xhr);
                console.log(xhr)
                setSlides(JSON.parse(xhr.response));
            };
            xhr.open('GET', url);
            xhr.send();
        });

    }, [])

    return (
        <IonPage>
            <IonContent>

                <Grid container spacing={2}>

                    <Grid item xs={12}>
                        <AppBar className={props.ios?classes.page_title_ios:classes.page_title} position="sticky">
                            <Toolbar>
                                <Typography className={classes.title} variant="h6">
                                    <span className={classes.left_align_block}>Bright DSM | How To Use
                  {isAuthenticated &&
                                            <span> | {user.email}</span>
                                        }
                                    </span>
                                    <span className={classes.right_align_block}>
                                        {!isAuthenticated && !Capacitor.isNative &&
                                            <Button onClick={() => loginWithRedirect()} className={classes.actionButton}>Log In as Admin</Button>
                                        }
                                        {isAuthenticated && !Capacitor.isNative &&
                                            <Button onClick={() => logout({ returnTo: window.location.origin })} className={classes.actionButton}>Log Out</Button>
                                        }
                                    </span>
                                </Typography>
                            </Toolbar>
                        </AppBar>
                    </Grid>

                    <Grid item xs={12}>

                        {slides.length > 0 &&
                            <IonSlides pager={true} options={slideOpts}>
                                {slides.map((a: any, ind: number) => {
                                    return (
                                        <IonSlide className={classes.fullslide} key={'slide_' + ind}>
                                            <Card className={classes.simple_white_card}>
                                                <CardContent>
                                                    <img src={a.img_url} alt=""/>
                                                    <Typography variant='h5'>{a.title}</Typography>
                                                    <Typography variant='body1'>{a.text}</Typography>
                                                </CardContent>
                                            </Card>
                                        </IonSlide>
                                    )
                                })}
                            </IonSlides>
                        }


                    </Grid>
                </Grid>
            </IonContent>
        </IonPage>

    );
};

export default HowToUse;
